import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const CircleClock: React.FC<IconComponentProps> = ({
  className,
  strokeWidth = '1.5',
}) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 14C11.3138 14 14 11.3138 14 8C14 4.68629 11.3138 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3138 4.68629 14 8 14Z"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 4.76929V8.00006H10.3077"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
